<template>
  <div id="app-login" v-if="!isDirectLogin">
    <app-form-login></app-form-login>
  </div>
</template>

<script>
  import appFormLogin from '../Forms/LoginForm';

  export default {
    name: 'app-login',
    components: {
      appFormLogin,
    },
    data() {
      return {
        isDirectLogin: localStorage.getItem('directSurveyId') && localStorage.getItem('directSurveyId').length > 0,
      };
    },
  };
  
</script>

<style>
  @media only screen and (min-width : 768px) {
    .login-form{
      width: 400px;
    }
  }
</style>

<style scoped>
  #app-login{
    position: relative;
    height: 100%;
    background: url('../../../static/ii_bg_optimized.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  };

  @media only screen and (max-width:568px) {
    #app-login{
      background: #00418a;
    }
  }

  .login-form{
    min-width: 270px;
    min-height: 420px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  };

  .el-button--primary{
    width: 100%;
  };

</style>



// WEBPACK FOOTER //
// Login.vue?5f81d842